const themeColors = {
    colorWhite: "#fff",
    colorBlack: "#000",
    colorBlueNew: "#259",
    colorBluish: "#f2f7f9",
    seaGreen: "#2e8b57",
    darkGgreen: "#5da423",
    lightBlue: "#1c3e95",
    errorRed: "#f04124",
    darkRed: "#C60F13",
    lightGray1: "#959595",
    lightGray2: "#f1f1f1",
    lightGray67: "#f7f7f7",
    lightGray3: "#bbb",
    lightGray4: "#dedede",
    lightGray5: "#e0e0e0",
    lightGray6: "#e4e4e4",
    lightGray7: "#8a8a8a",
    lightGray8: "#ccc",
    lightGray9: "#868686",
    lightGray10: "#919191",
    lightGray11: "#999",
    lightGray12: "#d2d3d4",
    lightGray13: "#aaa",
    lightGray14: "#fafafa",
    lightGray15: "#dfdfdf",
    lightGray16: "#66768F",
    lightGray17: "#e5e5e5",
    lightGray18: "#d8d8d8",
    lightGray19: "#f3f3f3",
    lightGray20: "#f9f9f9",
    drakBlue: "#2D568D",
    colorBlue: "#254674",
    colorBlue2: "#0082D8",
    colorBlue3: "#0099FF",
    drakYellow: "#df8d00",
    drakYellow2: "#F4A700",
    secondarybtn: "#7D8FA3",
    crosssellBorderColor: "#d8e0eb",
    neroColor: "#252525",
    faintBlue: "#3e6699",
    darkOrange: "#D77300",
    grayishWhite: "#f0f0f0",
    brightGreen: "#39b54a",
    lightSkyBlue: "#E8F0FE",
    tableOddcellBgcolor: "#f6f6f6",
    tableEvencellBgcolor: "#fff",
    colorGray: "#ccc",
    dodgerBlue: "#1e90ff",
    heavyBlue: "#0078a0",
    heavyBlue2: "#337ff1",
    heavyBlue3: "#3079f0",
    heavyblue4: "#0068D0",
    heavyblue5: "#0080FF",
    lightBlack: "#363636",
    colorPink: "#d70a8c",
    colorOrange: "#F38507",
    colorPurple: "#660066",
    dimBlack: "#696969",
    brightYellow: "#F6B900",
    dullBlue: "#7495BB",
    dullBlue2: "#5E7DAB",
    colorShadow: "#232323",
    colorDarkMidnightBlue: "#003366",
    colorRaisinBlack: "#222",
    colorHarbour: "#e1eaf6",
    colorPumpkinOrange: "#fa8208",

    fontFamilyArial: "Arial, Helvetica, sans-serif",
    fontFamilyProximanova: "ProximaNova, Helvetica, Arial, sans-serif",

    containerWidth: "1200px",
    containerInnerWidth: "1180px",

    lightGray: "#ddd",
    drakGray: "#333",
    defaultLinkGray: "#262",
    customBlue: "#006ae3",
    colorHr: "#666",
    // containerWidth: "1200px",
    headingColor: "#212529",
    primaryColor: "#cc0000",
    primaryColorHover: "#9d0101",
    primaryColorDisabled: "#ff5959",
    colorDisabled: "#f8f9fa",
    colorLightgray: "#f8f8f8",
    colorDarkgray: "#dadada",
    secondaryColorHover: "#e2e6ea",
    secondaryColorDisabled: "#b1b6bb",
    tertiaryColor: "#cc0000",
    tertiaryColorHover: "#f8f9fa",
    tertiaryColorBorder: "#d5d5d5",
    tertiaryBgColorHover: "#23272b",
    tertiaryColorDisabled: "#f8f9fa",
    tertiaryBgColorDisabled: "#7b7f83",
    grayColor: "#d5d5d5",
    inputColor: "#495057",
    orderBorderColor: "#dcdcdc",
    inputBorderColor: "#ced4da",
    inputDisabledBgColor: "#e9ecef",
    inputDisabledTextColor: "#868e96",
    breadcrumbColor: "#868e96",
    topBgColor: "#585858",
    gray15Color: "#262626",
    succcessColor: "#28a745",
    tabBorderColor: "#c4bfbf",
    subheadColor: "#bccde5",
    blueColor: "#398af2",
    disableColor: "#b1b1b1",
    blueDarkColor: "#00205d",
    black: "#000",
    gray16Color: "#cec9c9",
    gray83Color: "#4d4d4d",
    lightRedColor: "#eeeeee",
    colorNewBlack: "#0f0f0f",
    colorDisabledNew: "#aeaeae",
    colorTertiary: "#708090",
    colorTertiaryNew: "#808fa3",
    colorRedioNew: "#0075ff",
    colorAlaskaGray: "#dbdad1",
    colorGreyWhite: "#d6d5cb",
    colorMed: "#fdc308",
    colorLightBlue: '#e8f0fe',
    colorLightGrey: '#e9e9e9',
    formErrorColor: '#f20a0a',
    formSucessColor: '#00a500',

};
const themeFontWeights = {
    regular: 400,
    medium: 500,
    semiBold: 600,
    fontWeightForBold: 700,
    bold: "bold",
    fontWeightnormal: "normal",
};
const themeFontsSize = {
    size8: "8px",
    size10: "10px",
    size12: "12px",
    size1225: "12.25px",
    size13: "13px",
    size14: "14px",
    size15: "15px",
    size154: "15.4px",
    size16: "16px",
    size17: "17px",
    size18: "18px",
    size20: "20px",
    size21: "21px",
    size22: "22px",
    size24: "24px",
    size26: "26px",
    size28: "28px",
    size30: "30px",
    size32: "32px",
    size33: "33px",
    size34: "34px",
    size38: "38px",
    size40: "40px",
    size44: "44px",
    size175: "1.75em",
    size75: ".75em",
    size15em: "1.5em",
    
};
const themeFonts = {
    fontFamilyProximaNova: "'ProximaNova', Helvetica, Arial, sans-serif",
    fontFamilyMuseoSans: "MuseoSans",
    fontFamilyHelvetica: "Helvetica, Arial, sans-serif",
    fontFamilyArial: "Arial,Helvetica,sans-serif",
    fontFamilyGeriMedical: "Geriatric-Medical",
    fontFamilyTTFors: "TTfors, Helvetica, Arial, sans-serif",
    fontFamilyPoppinsRegular: "Poppins-Regular, Helvetica, Arial, sans-serif",
    fontFamilyPoppinsMedium: "Poppins-Medium, Helvetica, Arial, sans-serif",
    fontFamilyPoppinsBold: "Poppins-Bold, Helvetica, Arial, sans-serif",
    fontFamilyPoppinsItalic: "Poppins-Italic, Helvetica, Arial, sans-serif",
    fontFamilyPoppinsBlack: "Poppins-Black, Helvetica, Arial, sans-serif",
    fontFamilyPoppinsSemiBold: "Poppins-Semi-bold, Helvetica, Arial, sans-serif",
    fontFamilyPoppinsLight: "Poppins-Light, Helvetica, Arial, sans-serif",
    fontFamilyLexendDeca: "LexendDeca-Regular, Poppins-Light, Arial, sans-serif",
};
const themeIndents = {
    Indent8 : "8px",
    Indent11 : "11px",
    Indent12 : "12px",
    Indent20 : "20px",
    Indent22 : "22px",
    Indent23 : "23px",
    Indent24 : "24px",
};

export default themeColors;
export { themeFontWeights, themeFontsSize, themeFonts, themeIndents };